import React, { useEffect, useState } from "react";
import PreviewPage from "./learnosityPreviewPage";
import { useParams } from "react-router";
import QuestionExplanationPopup from "../../shared/common/questionExplanationPopup";
import { getQuestionByQuestionGuid } from "../../../api/question.service";
import { IQuestion } from "../../../model/interface/question";
import { IQuestionSetting } from "../../../model/interface/questionSetting";
import { IVideoExplanation } from "../../../model/interface/videoExplanation";

export const PublicItemPreview = () => {
  const [languageId, setLanguageId] = useState<number>(1);
  const [showPopup, setShowPopup] = useState(false);
  const [textExplanation, setTextExplanation] = useState<string>("");
  const [showTextExplanation, setShowTextExplanation] =
    useState<boolean>(false);
  const [showRubric, setShowRubric] = useState<boolean>(false);
  const [rubric, setRubric] = useState<string>("");
  const [videoUrl, setVideoUrl] = useState<string>("");
  const [vttUrl, setVttUrl] = useState<string>("");
  const [question, setQuestion] = useState<IQuestion>();
  const [itemReference, setItemReference] = useState<string | undefined>();
  const [videoExplanation, setVideoExplanation] =
    useState<IVideoExplanation | null>(null);
  const params = useParams() as any;

  const onToggleLanguageClick = () => {
    if (!question || !question.settings) return;

    const newLanaguageId = languageId === 1 ? 2 : 1;
    setLanguageId(newLanaguageId);
  };

  const displayTextExplanationPopup = () => {
    setVideoUrl("");
    setShowRubric(false);
    setShowTextExplanation(true);
    setShowPopup(true);
  };

  const showVideoExplanation = (videoExplanation: IVideoExplanation) => {
    setVideoUrl(videoExplanation.explanation);
    setVttUrl(videoExplanation.vttUrl || "");
    setShowRubric(false);
    setShowTextExplanation(false);
    setShowPopup(true);
  };

  function displayRubricPopup() {
    setVideoUrl("");
    setShowTextExplanation(false);
    setShowRubric(true);
    setShowPopup(true);
  }

  useEffect(() => {
    if (!question || !question.settings) return;

    const questionSetting = question.settings.find(
      (r) => r.languageId === languageId
    );

    if (questionSetting) {
      const explanation = questionSetting.videoExplanation
        ? questionSetting.videoExplanation.trim()
        : "";
      setVideoExplanation({
        explanation: explanation,
        vttUrl: questionSetting?.videoExplanationVttUrl || null,
      } as IVideoExplanation);
    }

    setItemReference(
      languageId === 1
        ? question.englishQuestionReferenceId
        : question.spanishQuestionReferenceId
    );
  }, [languageId, question]);

  useEffect(() => {
    getQuestionByQuestionGuid(params.id).then((data) => {
      setQuestion(data.data);
    });
  }, []);

  return (
    <>
      {showPopup && (
        <QuestionExplanationPopup
          showPopUp={(show) => {
            setShowPopup(show);
          }}
          textExplanation={
            showRubric ? rubric : showTextExplanation ? textExplanation : ""
          }
          videoUrl={videoUrl}
          vttUrl={vttUrl}
          studentType={""}
          itemRef={itemReference}
        />
      )}
      <header className="px-4 pt-4 bg-gray-50 relative">
        <div className="flex justify-between my-4">
          <div className="flex items-center space-x-4">
            <label
              htmlFor="toggleSpanish"
              className="flex items-center cursor-pointer pl-1"
            >
              <div className="relative">
                <input
                  id="toggleSpanish"
                  type="checkbox"
                  className="sr-only"
                  onChange={onToggleLanguageClick}
                />
                <div className="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                <div
                  className={`${
                    languageId === 2 ? "bg-primary-color toggle-btn" : ""
                  } absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition`}
                ></div>
              </div>
              <div className="ml-3 text-gray-700 font-medium">
                Spanish Version
              </div>
            </label>
            <span className={"pl-5 font-bold text-lg"}>
              Question ID: {question?.questionId}
            </span>
            {rubric && rubric !== "" && (
              <a
                className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                onClick={() => {
                  displayRubricPopup();
                }}
              >
                Rubric
              </a>
            )}
            {textExplanation && textExplanation !== "" && (
              <a
                className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                onClick={() => {
                  displayTextExplanationPopup();
                }}
              >
                Text Explanation
              </a>
            )}

            {videoExplanation && videoExplanation.explanation !== "" && (
              <a
                className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                onClick={() => {
                  showVideoExplanation(videoExplanation);
                }}
              >
                Video Explanation
              </a>
            )}
          </div>
        </div>
      </header>
      <div className="w-full h-full relative overflow-auto px-4 py-3 ">
        <img
          alt="Progress Learning"
          src="/images/logo-pl.svg"
          className="w-16 ml-4 mb-1 "
        />
        <PreviewPage
          key={`${params.id}-${languageId}`}
          showTextToSpeech={true}
          questionGuid={params.id}
          languageId={languageId}
          onSetTextExplanation={(textExplanation: string) => {
            setTextExplanation(textExplanation);
          }}
          onSetRubric={(rubric: string) => {
            setRubric(rubric);
          }}
        />
      </div>
    </>
  );
};
